/* Dati fiscali carrello.
   Scrive gli attributi via Cart AJAX API invece di affidarsi al submit del
   form: i campi stanno fuori dal <form id="cart"> e non verrebbero inviati.
   Tutti i listener sono in delega su document, così sopravvivono ai
   re-render del carrello fatti da component-cart.js. */
(function () {
  const FIELDS = ['ragione_sociale', 'partita_iva', 'codice_sdi', 'pec'];
  let debounceId;
  let pending = null;

  const blocks = () => document.querySelectorAll('[data-fiscal-data]');

  // Route del tema: corretto anche su domini localizzati (/it, /en)
  const updateUrl = () =>
    (window.KROWN?.settings?.routes?.cart_update_url || '/cart/update') + '.js';

  function collect(block) {
    const checked = block.querySelector('[data-fiscal-type]:checked');
    const tipo = checked ? checked.value : 'Privato';
    const attrs = { tipo_acquirente: tipo };
    FIELDS.forEach((k) => {
      const input = block.querySelector(`[data-fiscal-field="${k}"]`);
      // tornando a Privato svuotiamo tutto: evita ordini con P.IVA residua
      attrs[k] = tipo === 'Azienda' && input ? input.value.trim() : '';
    });
    return attrs;
  }

  // Riallinea ogni blocco presente (pagina + drawer) allo stesso stato
  function applyState(block, attrs) {
    block.querySelectorAll('[data-fiscal-type]').forEach((r) => {
      r.checked = r.value === attrs.tipo_acquirente;
    });
    const fields = block.querySelector('[data-fiscal-fields]');
    if (fields) fields.hidden = attrs.tipo_acquirente !== 'Azienda';
    FIELDS.forEach((k) => {
      const input = block.querySelector(`[data-fiscal-field="${k}"]`);
      if (input && input !== document.activeElement) input.value = attrs[k];
    });
  }

  function sync(source) {
    const attrs = collect(source);
    blocks().forEach((b) => applyState(b, attrs));
    pending = fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    })
      .catch((err) => console.error('[fiscal-data] update fallito', err))
      .finally(() => { pending = null; });
    return pending;
  }

  function validate(block) {
    const checked = block.querySelector('[data-fiscal-type]:checked');
    if (!checked || checked.value !== 'Azienda') return null;
    const v = (k) =>
      (block.querySelector(`[data-fiscal-field="${k}"]`)?.value || '').trim();
    if (!v('ragione_sociale')) return 'Inserisci la ragione sociale.';
    if (!/^\d{11}$/.test(v('partita_iva').replace(/\s|IT/gi, '')))
      return 'Partita IVA non valida (11 cifre).';
    if (!v('codice_sdi') && !v('pec'))
      return 'Inserisci il Codice SDI oppure la PEC.';
    return null;
  }

  document.addEventListener('change', (e) => {
    const block = e.target.closest?.('[data-fiscal-data]');
    if (!block || !e.target.matches('[data-fiscal-type], [data-fiscal-field]')) return;
    sync(block);
  });

  document.addEventListener('input', (e) => {
    const block = e.target.closest?.('[data-fiscal-data]');
    if (!block || !e.target.matches('[data-fiscal-field]')) return;
    clearTimeout(debounceId);
    debounceId = setTimeout(() => sync(block), 500);
  });

  // capture:true per intercettare prima del submit handler del tema
  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('#CheckOut, [name="checkout"]');
    if (!btn) return;

    const block =
      btn.closest('[data-fiscal-data]') || document.querySelector('[data-fiscal-data]');
    if (!block) return;

    const errorEl = block.querySelector('[data-fiscal-error]');
    const error = validate(block);
    if (error) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (errorEl) { errorEl.textContent = error; errorEl.hidden = false; }
      block.querySelector('[data-fiscal-fields] input')?.focus();
      return;
    }
    if (errorEl) errorEl.hidden = true;

    // aspettiamo l'update in volo, altrimenti si va in cassa senza attributi
    if (btn.dataset.fiscalReady !== '1') {
      e.preventDefault();
      e.stopImmediatePropagation();
      clearTimeout(debounceId);
      sync(block).then(() => {
        btn.dataset.fiscalReady = '1';
        btn.click();
        delete btn.dataset.fiscalReady;
      });
    }
  }, true);

  // Failsafe: carrello con attributo vuoto -> nessun radio selezionato
  document.addEventListener('DOMContentLoaded', () => {
    blocks().forEach((b) => {
      if (!b.querySelector('[data-fiscal-type]:checked')) {
        const priv = b.querySelector('[data-fiscal-type][value="Privato"]');
        if (priv) priv.checked = true;
      }
    });
  });
})();